import debounce from "lodash/debounce";
import { useLayoutEffect, useState } from "react";

const useHasScrollbar = (elt) => {
  const [hasScrollbar, setHasScrollbar] = useState(false);

  useLayoutEffect(() => {
    if (!elt) {
      return;
    }
    const onResizeDebounced = debounce((entries) => {
      for (let entry of entries) {
        const el = entry.target;
        // Check if the content height exceeds the visible area
        const hasScrollbar = el.scrollHeight > el.clientHeight;
        setHasScrollbar(hasScrollbar);
      }
    }, 500);

    const observer = new ResizeObserver(onResizeDebounced);

    // Target your container element
    observer.observe(elt);

    return () => {
      observer.disconnect();
    };
  }, [elt]);

  return hasScrollbar;
};

export default useHasScrollbar;
